// extracted by mini-css-extract-plugin
module.exports =  {"image":"zT30Mh6"};